import { render, staticRenderFns } from "./CategoryAvgSessionByDayChart.vue?vue&type=template&id=8dd3c2f0&"
import script from "./CategoryAvgSessionByDayChart.vue?vue&type=script&lang=js&"
export * from "./CategoryAvgSessionByDayChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports